import { render } from "./Extratos.vue?vue&type=template&id=0a00423e&scoped=true"
import script from "./Extratos.vue?vue&type=script&lang=js"
export * from "./Extratos.vue?vue&type=script&lang=js"

import "./Extratos.vue?vue&type=style&index=0&id=0a00423e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a00423e"]])

export default __exports__